export function getDesktopSize(window) {
  const width = (window.screen && window.screen.width) || 0;
  const height = (window.screen && window.screen.height) || 0;

  return `${width}x${height}`;
}

export function getWindowSize(window) {
  let width = 0;
  let height = 0;

  if (window.innerWidth) {
    width = window.innerWidth;
    height = window.innerHeight;
  } else if (window.document) {
    if (window.document.documentElement && window.document.documentElement.clientWidth) {
      width = window.document.documentElement.clientWidth;
      height = window.document.documentElement.clientHeight;
    } else if (window.document.body && window.document.body.clientWidth) {
      width = window.document.body.clientWidth;
      height = window.document.body.clientHeight;
    }
  }

  return `${width}x${height}`;
}



// WEBPACK FOOTER //
// ./lib/screen.js